__turbopack_context__.v({
  "accordion-content": "calculator-layout-module-scss-module__f9jjkq__accordion-content",
  "accordion-item": "calculator-layout-module-scss-module__f9jjkq__accordion-item",
  "calculator-content": "calculator-layout-module-scss-module__f9jjkq__calculator-content",
  "calculator-input-row": "calculator-layout-module-scss-module__f9jjkq__calculator-input-row",
  "label": "calculator-layout-module-scss-module__f9jjkq__label",
  "modal-box-cta": "calculator-layout-module-scss-module__f9jjkq__modal-box-cta",
  "modal-content": "calculator-layout-module-scss-module__f9jjkq__modal-content",
  "placeholder": "calculator-layout-module-scss-module__f9jjkq__placeholder",
});
